import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import SavedProvider from "./context/saved";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SavedProvider>
    <App />
    <ToastContainer theme="colored" draggable />
  </SavedProvider>
);
